// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorDialogUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var tinycolor = require('tinycolor2');
  const { forEach } = require('lodash/fp');

  function toState(data, oldHue,alpha) {
    var color = data && data.hex ? tinycolor(data.hex) : tinycolor(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }

    return {
      hsl,
      hex: '#' + color.toHex(),
      rgb: color.toRgb(),
      hsv,
      oldHue: data && data.h || oldHue || hsl.h,
      source: data && data.source,
      alpha: alpha
    };
  }

  function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
    var checked = 0;
    var passed = 0;
    forEach(function(letter) {
      if (data[letter]) {
        checked++;
        if (!isNaN(data[letter])) {
          passed++;
        }
      }
    }, keysToCheck);

    return checked === passed ? data : false;
  }

  function isValidHex(hex) {
    return tinycolor(hex).isValid();
  }

  function saturationCalculateChange(e, skip, props, container) {
    !skip && e.preventDefault();
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
    var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
    var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));

    if (left < 0) {
      left = 0;
    } else if (left > containerWidth) {
      left = containerWidth;
    } else if (top < 0) {
      top = 0;
    } else if (top > containerHeight) {
      top = containerHeight;
    }

    var saturation = left * 100 / containerWidth;
    var bright = -(top * 100 / containerHeight) + 100;

    return {
      h: props.hsl.h,
      s: saturation,
      v: bright,
      a: props.hsl.a,
      source: 'rgb'
    };
  }

  function hueCalculateChange(e, skip, props, container) {
    !skip && e.preventDefault();
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
    var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
    var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));

    if (props.direction === 'vertical') {
      var h;
      if (top < 0) {
        h = 359;
      } else if (top > containerHeight) {
        h = 0;
      } else {
        var percent = -(top * 100 / containerHeight) + 100;
        h = 360 * percent / 100;
      }

      if (props.hsl.h !== h) {
        return {
          h,
          s: props.hsl.s,
          l: props.hsl.l,
          a: props.hsl.a,
          source: 'rgb'
        };
      }
    }
    return null;
  }

  function convertHexToRGBA(colorCode,alpha){
    var color =  tinycolor(colorCode);
    color.setAlpha(alpha);
    return color.toRgbString();
  }

  module.exports = {
    simpleCheckForValidColor: simpleCheckForValidColor,
    toState: toState,
    isValidHex: isValidHex,
    saturationCalculateChange: saturationCalculateChange,
    hueCalculateChange: hueCalculateChange,
    convertHexToRGBA:convertHexToRGBA
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorDialog/Izenda.ColorDialogUtils.js